import { render, staticRenderFns } from "./mobile_tarif.vue?vue&type=template&id=478f0ea6&scoped=true&"
import script from "./mobile_tarif.vue?vue&type=script&lang=js&"
export * from "./mobile_tarif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478f0ea6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('478f0ea6')) {
      api.createRecord('478f0ea6', component.options)
    } else {
      api.reload('478f0ea6', component.options)
    }
    module.hot.accept("./mobile_tarif.vue?vue&type=template&id=478f0ea6&scoped=true&", function () {
      api.rerender('478f0ea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/user/profile/tabs/mobile_tarif.vue"
export default component.exports